import { hasAnalyticsConsent } from './consent';

const SCRIPT_ID = 'ga-gtag-script';

// Ölçüm kimliği fonksiyon içinde okunur; modül seviyesinde sabitlenirse
// testlerde ve farklı ortamlarda değiştirilemez hâle gelir.
const getMeasurementId = () => process.env.REACT_APP_GA_ID;

export const isAnalyticsLoaded = () => Boolean(document.getElementById(SCRIPT_ID));

export const loadAnalytics = () => {
  const measurementId = getMeasurementId();

  if (!measurementId) return false;
  if (!hasAnalyticsConsent()) return false;
  if (isAnalyticsLoaded()) return false;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());

  // send_page_view: false — ilk görüntülemeyi trackPageView() gönderiyor,
  // aksi hâlde açılış sayfası iki kez sayılır.
  gtag('config', measurementId, { send_page_view: false });

  return true;
};

export const trackPageView = (path) => {
  if (!getMeasurementId()) return false;
  if (!hasAnalyticsConsent()) return false;
  if (typeof window.gtag !== 'function') return false;

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });

  return true;
};

export const clearAnalyticsCookies = () => {
  const { hostname } = window.location;
  const parts = hostname.split('.');

  // Aynı çerez farklı domain kapsamlarında yazılmış olabilir; hepsini dene.
  const domains = [hostname, `.${hostname}`];
  if (parts.length > 2) domains.push(`.${parts.slice(-2).join('.')}`);

  document.cookie.split(';').forEach((entry) => {
    const name = entry.split('=')[0].trim();
    if (name !== '_ga' && name !== '_gid' && !name.startsWith('_ga_')) return;

    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    domains.forEach((domain) => {
      document.cookie = `${name}=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    });
  });
};
